import { render, staticRenderFns } from "./Alumni.vue?vue&type=template&id=a3df7914"
import script from "./Alumni.vue?vue&type=script&lang=js"
export * from "./Alumni.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports